var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#2C71C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5332 20.9365C16.0254 20.9365 16.4424 20.5127 16.4424 20.0479V15.9805H20.4209C20.8994 15.9805 21.3164 15.5703 21.3164 15.0713C21.3164 14.5791 20.8994 14.1621 20.4209 14.1621H16.4424V10.0947C16.4424 9.61621 16.0254 9.20605 15.5332 9.20605C15.0342 9.20605 14.624 9.61621 14.624 10.0947V14.1621H10.6455C10.1807 14.1621 9.74316 14.5791 9.74316 15.0713C9.74316 15.5703 10.1807 15.9805 10.6455 15.9805H14.624V20.0479C14.624 20.5127 15.0342 20.9365 15.5332 20.9365Z",
    fill: "#2C71C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddApp);
export default __webpack_public_path__ + "static/media/add-app.4585139c53cb925021fa79f267ab90cd.svg";
export { ForwardRef as ReactComponent };